import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

// Create FAQ POST API
export const createFaq = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/create_faq/`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Create FAQ API error:", error);
    throw error;
  }
};

// Get All(public and private) FAQs for admin
export const getAllFaq = async () => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/api/get_all_faq/`);
    return response.data;
  } catch (error) {
    console.error("Fetch FAQ API error:", error);
    throw error;
  }
};

//To update the FAQ
export const updateFaq = async (faqId, payload) => {
  const response = await axiosInstance.put(
    `${apiUrl}/api/update_faq/${faqId}/`,
    payload,
  );
  return response;
};

export const deleteFaq = async (faqId) => {
  const response = await axiosInstance.delete(
    `${apiUrl}/api/delete_faq/${faqId}/`,
  );
  return response;
};

//fetch FAQ for client and contatct (private)
export const getFaq = async () => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/api/get_faq/`);
    return response.data;
  } catch (error) {
    console.error("Fetch FAQ API error:", error);
    throw error;
  }
};
